import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { CheckoutPage } from './pages/CheckoutPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SalesPage data-id="element-3" />} data-id="element-2" />
        <Route path="/checkout" element={<CheckoutPage data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}